import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { CountriesService } from './countries.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppConfigService {
  private baseUrl = environment.API;
  config;
  configSubject: BehaviorSubject<any> = new BehaviorSubject<any>('null');

  constructor(
    private http: HttpClient,
    private countriesService: CountriesService
  ) {}

  load() {
    const url = `${this.baseUrl}/apps/config/`;
    console.log(url);

    this.http.get(url).subscribe(config => {
      this.config = config;
      this.configSubject.next(config);
      this.countriesService.setCountries(config['countries'], config['geo_info']);
    }, () => {
      this.config = {};
    } );
  }
}
